import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-outer-wrapper">
        <div className="navigation-container">
          <div className="navigation-brand-area">
            <a href="/">
              <div aria-label="MDMC.dev Home" className="navigation-logo-link">
                <div className="navigation-logo-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="1" cx="12" cy="12"></circle>
                      <path d="M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9c-4.54-4.52-9.87-6.54-11.9-4.5c-2.04 2.03-.02 7.36 4.5 11.9c4.54 4.52 9.87 6.54 11.9 4.5"></path>
                      <path d="M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9c-2.03-2.04-7.36-.02-11.9 4.5c-4.52 4.54-6.54 9.87-4.5 11.9c2.03 2.04 7.36.02 11.9-4.5"></path>
                    </g>
                  </svg>
                </div>
                <span className="navigation-brand-name section-title">
                  <span>
                    {' '}
                    MDMC
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="navigation-thq-navigation-dot-elm">.</span>
                  <span>
                    {' '}
                    dev
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
            </a>
          </div>
          <div className="navigation-desktop-menu">
            <ul className="navigation-links-list">
              <li className="navigation-link-item">
                <a href="/meme-generator">
                  <div className="navigation-link">
                    <span>Meme Generator</span>
                  </div>
                </a>
              </li>
              <li className="navigation-link-item">
                <a href="/library">
                  <div className="navigation-link">
                    <span>Dank Library</span>
                  </div>
                </a>
              </li>
              <li className="navigation-link-item">
                <a href="/collider">
                  <div className="navigation-link">
                    <span>Collider</span>
                  </div>
                </a>
              </li>
              <li className="navigation-link-item">
                <a href="/facility">
                  <div className="navigation-link">
                    <span>Facility</span>
                  </div>
                </a>
              </li>
              
            </ul>
            <div className="navigation-actions">
            <a href="https://tx.wtf" target="_blank" rel="noopener noreferrer">
                <div className="btn btn-primary btn-sm">
                <span>tx.wtf</span>
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </a>
            </div>
          </div>
          <button
            id="nav-toggle"
            aria-label="Toggle Menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              className="navigation-icon-open"
            >
              <path
                d="M4 6h16M4 12h16M4 18h16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobile-overlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <div className="navigation-brand-area">
            <div className="navigation-logo-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="1" cx="12" cy="12"></circle>
                  <path d="M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9c-4.54-4.52-9.87-6.54-11.9-4.5c-2.04 2.03-.02 7.36 4.5 11.9c4.54 4.52 9.87 6.54 11.9 4.5"></path>
                  <path d="M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9c-2.03-2.04-7.36-.02-11.9 4.5c-4.52 4.54-6.54 9.87-4.5 11.9c2.03 2.04 7.36.02 11.9-4.5"></path>
                </g>
              </svg>
            </div>
            <span className="navigation-brand-name section-title">
              MDMC.dev
            </span>
          </div>
          <button
            id="nav-close"
            aria-label="Close Menu"
            className="navigation-mobile-close"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-5.5-3.5l-5 5m0-5l5 5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <ul className="navigation-mobile-links">
            <li className="navigation-mobile-item">
              <a href="/meme-generator">
                <div className="navigation-mobile-link">
                  <span>Meme Generator</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/library">
                <div className="navigation-mobile-link">
                  <span>Dank Library</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/collider">
                <div className="navigation-mobile-link">
                  <span>Collider</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/facility">
                <div className="navigation-mobile-link">
                  <span>Facility</span>
                </div>
              </a>
            </li>
            
          </ul>
          <div className="navigation-mobile-actions">
            <a href="https://tx.wtf" target="_blank" rel="noopener noreferrer">
              <div className="btn btn-primary btn-lg">
                <span>tx.wtf</span>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </a>
          </div>
          <div className="navigation-meme-decor">
            <div className="navigation-meme-text">
              <span>MAXIMUM DANKNESS DETECTED</span>
            </div>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
        @keyframes pulse {0%,100% {opacity: 0.5;}
50% {opacity: 1;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById("nav-toggle")
  const navClose = document.getElementById("nav-close")
  const mobileOverlay = document.getElementById("mobile-overlay")
  const body = document.body

  function openMenu() {
    mobileOverlay.classList.add("is-active")
    navToggle.setAttribute("aria-expanded", "true")
    body.style.overflow = "hidden"
  }

  function closeMenu() {
    mobileOverlay.classList.remove("is-active")
    navToggle.setAttribute("aria-expanded", "false")
    body.style.overflow = ""
  }

  navToggle.addEventListener("click", openMenu)
  navClose.addEventListener("click", closeMenu)

  mobileOverlay.addEventListener("click", (e) => {
    if (e.target.classList.contains("navigation-mobile-link")) {
      closeMenu()
    }
  })

  let lastScroll = 0
  const navWrapper = document.querySelector(".navigation-outer-wrapper")

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset

    if (currentScroll <= 0) {
      navWrapper.style.transform = "translateY(0)"
      navWrapper.style.boxShadow = "0 8px 32px color-mix(in srgb, var(--color-surface) 50%, black)"
      return
    }

    if (currentScroll > lastScroll && currentScroll > 100) {
      navWrapper.style.transform = "translateY(-150%)"
    } else {
      navWrapper.style.transform = "translateY(0)"
      navWrapper.style.background = "color-mix(in srgb, var(--color-surface) 85%, transparent)"
    }

    lastScroll = currentScroll
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
